import {
  range_styles_default
} from "./chunk.ZCYQEUX4.js";
import {
  form_control_styles_default
} from "./chunk.EK4QQDDG.js";
import {
  component_mobile_styles_default
} from "./chunk.3DO35SD7.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/range/range.styles.ts
var range_styles_default2 = r` ${range_styles_default} ${component_mobile_styles_default} ${form_control_styles_default} :host { --track-color-active: var(--sl-color-gray-400); --track-color-inactive: var(--sl-color-gray-400); } `;

export {
  range_styles_default2 as range_styles_default
};
